// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XdRm","left":"styles_left__1WGEi"};